__turbopack_context__.v({
  "card": "styles-module__YPGTPa__card",
  "cardLink": "styles-module__YPGTPa__cardLink",
  "content": "styles-module__YPGTPa__content",
  "icon": "styles-module__YPGTPa__icon",
  "iconWrapper": "styles-module__YPGTPa__iconWrapper",
  "title": "styles-module__YPGTPa__title",
  "value": "styles-module__YPGTPa__value",
});
